import { render, staticRenderFns } from "./Equipe.vue?vue&type=template&id=6a95bbc4&scoped=true"
import script from "./Equipe.vue?vue&type=script&lang=js"
export * from "./Equipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a95bbc4",
  null
  
)

export default component.exports